let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "for experienced product managers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Unlimited Access to VODs',
        trackLink: 'https://geekle.us/ticket/1626701975692x727654776688083000',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "for product managers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1626701702935x666987370800742400',
    },
];

export default PackagesItem;
